import React from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import personal from "../../assets/images/loan.png";
import car from "../../assets/images/car.png";
import home from "../../assets/images/home.png";

const BusinessLoans= () => {
  return (
    <div>
      <SimpleHero
        title="Capital to grow your business"
        subtitle="Lines of credit, term loans, and commercial real estate financing with clear guidance."
        primaryLabel="Talk to lending"
        primaryHref="/contact"
        variant="sofi"
        imageSrc={personal}
        imageAlt="Business lending"
        imageOn="right"
        tiltImage
        badges={["Lines of credit","Term loans","CRE financing"]}
      />
      <FeatureList
        items={[
          { icon: personal, title: 'Lines of credit', desc: 'Flexible access to working capital.' },
          { icon: car, title: 'Term loans', desc: 'Predictable payments for big purchases.' },
          { icon: home, title: 'CRE financing', desc: 'Finance or refinance your property.' },
        ]}
      />
      <section className="section text-center">
        <div className="gn-container">
          <a className="btn btn-gn-primary" href="/contact">Start application</a>
        </div>
      </section>
    </div>
  );
};

export default BusinessLoans;

